import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarPatrimonio(api, parametros) {       
    parametros.operacao = 'buscarPatrimonio';
    let retorno = {};

    await api.santriGET('/rest/patrimonio', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
  
}


// WEBPACK FOOTER //
// ./src/components/Rest/RPatrimonio.js